/* #region header */
/**************************************************************************************************
//
//  Description: Custodian drop down, refactored from asd forms
//
//  Copyright:    © 2020 - 2021 Aligned Assets Limited
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier            Issue# Description
//#region Version 1.0.0.0 changes
//    001   27.01.21 Peter Bryden               Initial Revision.
//    002   08.02.21 Sean Flook         WI38232 Set requiredField.
//    003   10.03.21 Sean Flook         WI39198 Do not explicitly set the width of the avatar.
//#endregion Version 1.0.0.0 changes
//
//--------------------------------------------------------------------------------------------------
//#endregion header */

/* #region imports */
import React, { useState } from "react";
import AAAvatarSelect from "../AAAvatarSelect";

/* #endregion imports */

const ASD_CustodianDropDown = ({ custodian_data, selectedValue, changeHandler, dataRequired }) => {
  const dataKey = "swaOrgRef";
  const dataText = "swaOrgNameText";
  const handleChange = (event) => { if (changeHandler != null) changeHandler(event.value[dataKey]); }

  const [data, setData] = useState(custodian_data);
  const [selectedKey, setSelectedKey] = useState(selectedValue);

  return (
    <AAAvatarSelect
      data={data}
      avatarField={dataKey}
      textField={dataText}
      keyField={dataKey}
      placeholder="choose Custodian"
      selectedKey={selectedKey}
      colour="greyWide"
      requiredField={dataRequired}
      onChange={handleChange}
    />
  );
}

export default ASD_CustodianDropDown;